export const PREFECTURES = [
  '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
  '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
  '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県',
  '岐阜県', '静岡県', '愛知県', '三重県',
  '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
  '鳥取県', '島根県', '岡山県', '広島県', '山口県',
  '徳島県', '香川県', '愛媛県', '高知県',
  '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
]

export const FORM_STEPS = {
  1: { title: '希望条件', description: 'ご希望の勤務地や職種を選択' },
  2: { title: '経験・職種', description: '経験年数と希望職種を入力' },
  3: { title: '基本情報', description: 'お名前や生年月日を入力' },
  4: { title: '連絡先', description: '電話番号とメールアドレスを入力' }
}

export const TIMING_OPTIONS = [
  { value: 'すぐにでも', label: 'すぐにでも' },
  { value: '3ヶ月以内', label: '3ヶ月以内' },
  { value: '6ヶ月以内', label: '6ヶ月以内' },
  { value: '1年以内', label: '1年以内' },
  { value: '1年以上', label: '1年以上' },
  { value: '未定', label: '未定' }
]

export const JOB_OPTIONS = [
  { value: '事務長', label: '事務長' },
  { value: '医事課（管理職）', label: '医事課（管理職）' },
  { value: '総務（管理職）', label: '総務（管理職）' },
  { value: '上記以外（管理職）', label: '上記以外（管理職）' },
  { value: '医事課（一般職）', label: '医事課（一般職）' },
  { value: '総務（一般職）', label: '総務（一般職）' },
  { value: '上記以外（一般職）', label: '上記以外（一般職）' }
]

export const EXPERIENCE_OPTIONS = [
  { value: 1, label: '1～4年' },
  { value: 5, label: '5～10年' },
  { value: 11, label: '11年～19年' },
  { value: 20, label: '20年以上' },
  { value: 0, label: '未経験' }
]

export const WORKPLACE_OPTIONS = [
  { value: '急性期', label: '急性期' },
  { value: 'ケアミックス', label: 'ケアミックス' },
  { value: '慢性期', label: '慢性期' },
  { value: 'クリニック', label: 'クリニック' },
  { value: '在宅', label: '在宅' }
]

export const SALARY_OPTIONS = [
  { value: '200', label: '200万円以上' },
  { value: '300', label: '300万円以上' },
  { value: '400', label: '400万円以上' },
  { value: '500', label: '500万円以上' },
  { value: '600', label: '600万円以上' },
  { value: '700', label: '700万円以上' },
  { value: '800', label: '800万円以上' },
  { value: '900', label: '900万円以上' }
]

export const TIME_OPTIONS = [
  '09:30', '10:00', '11:00', '12:00', '13:00',
  '14:00', '15:00', '16:00', '17:00', '18:00'
]

export const EXPERIENCE_JOB_OPTIONS = [
  '事務長(候補含む)・事務管理職',
  '医療事務（医事課）',
  '診療情報管理士',
  '総務',
  '人事・労務',
  '財務・経理',
  '施設・用度',
  '経営企画',
  '地域連携・社会福祉士',
  '医師事務作業補助',
  'システム',
  'その他'
]
